import { render, staticRenderFns } from "./ReasonForDisposal.vue?vue&type=template&id=bcebe8a8&scoped=true&"
import script from "./ReasonForDisposal.vue?vue&type=script&lang=js&"
export * from "./ReasonForDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcebe8a8",
  null
  
)

export default component.exports